import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import StaggeredAnimation from '../../components/ui/staggered-animation';

const Vault = () => {
  return (
    <div className="space-y-6">
      <StaggeredAnimation delay={100} animation="fadeUp">
        <div>
          <h1 className="text-3xl font-bold text-foreground">📈 Vault</h1>
          <p className="text-muted-foreground">Strategy docs, board notes, financial projections</p>
        </div>
      </StaggeredAnimation>

      <StaggeredAnimation delay={200} animation="fadeUp">
        <Card>
          <CardHeader>
            <CardTitle>Vault Dashboard</CardTitle>
            <CardDescription>Strategy docs, board notes, financial projections</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">Vault content will be displayed here...</p>
          </CardContent>
        </Card>
      </StaggeredAnimation>
    </div>
  );
};

export default Vault;